export default __webpack_public_path__ + "3eb1fbb3485eec128e4bc77bb48eaffd.svg";